import React from "react";
import HeroCarousel from "./HeroCarousel";
import Hero from "./Hero";
import ImageGrid from "./ImageGrid";
import ImageLinkRow from "./ImageLinkRow";
import Masonry from "./Masonry";
import TextImageBlock from "./TextImageBlock";
import Quote from "./Quote";
import CalloutButton from "./CalloutButton";
import LocationsGrid from "./LocationsGrid";
import ContactForm from "./ContactForm";

const conditionallyRenderTitle = ({ title, opensInModal }) => {
  if (opensInModal) {
    return (
      <section className="section has-title">
        <div className="container">
          <div className="columns is-mobile is-centered">
            <div className="is-11 column has-text-centered">
              <h1>{title}</h1>
            </div>
          </div>
        </div>
      </section>
    );
  }
  return null;
};

export default ({ title, content, opensInModal, locale }) => {
  return (
    <div className="is-page-content">
      {conditionallyRenderTitle({ title, opensInModal })}
      {content.map(item => {
        switch (item.type) {
          case "DatoCmsHeroCarousel":
            return (
              <HeroCarousel key={item.id} carouselItems={item.carouselItems} />
            );
            break;
          case "DatoCmsHero":
            return <Hero key={item.id} isFull={true} {...item} />;
            break;
          case "DatoCms4ImageRow":
            return (
              <ImageGrid key={item.id} prefix={item.id} images={item.images} />
            );
          case "DatoCmsImageLinkRow":
            return (
              <ImageLinkRow key={item.id} prefix={item.id} links={item.links} />
            );
          case "DatoCmsMasonry":
            return (
              <Masonry
                key={item.id}
                tagline={item.tagline}
                images={item.images}
              />
            );
          case "DatoCmsParagraph":
            return (
              <section key={item.id} className="section has-paragraph">
                <div className="container">
                  <div className="columns is-mobile is-centered">
                    <div className="is-11 column">
                      <div
                        className="content"
                        dangerouslySetInnerHTML={{
                          __html: item.contentNode.childMarkdownRemark.html
                        }}
                      />
                    </div>
                  </div>
                </div>
              </section>
            );
          case "DatoCmsTextImageBlock":
            return (
              <TextImageBlock
                key={item.id}
                prefix={item.id}
                html={item.textNode.childMarkdownRemark.html}
                image={item.image}
                orientation={item.orientation}
              />
            );
          case "DatoCmsQuote":
            return (
              <Quote
                key={item.id}
                html={item.contentNode.childMarkdownRemark.html}
              />
            );
          case "DatoCmsCalloutButton":
            return (
              <section key={item.id} className="section has-callout-button">
                <div className="container">
                  <div className="columns is-mobile is-centered">
                    <div className="is-12 column has-text-centered">
                      <CalloutButton
                        key={item.id}
                        label={item.label}
                        link={item.link}
                      />
                    </div>
                  </div>
                </div>
              </section>
            );
          case "DatoCmsLocationsGrid":
            return (
              <LocationsGrid
                key={item.id}
                prefix={item.id}
                locations={item.locations}
                locale={locale}
              />
            );
          case "DatoCmsEmbeddedForm":
            switch (item.form.slug) {
              case "contact-form-en":
              case "contact-form-fr":
              default:
                return <ContactForm key={item.id} form={item.form} />;
                break;
            }
            break;
          default:
            return <div key={item.id} />;
            break;
        }
      })}
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/components/PageContent.js